
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import KeyboardInput from "../InputKeyboard";
import { ClosePopup, OpenPopup } from "../../../actions/ui";
import { t } from "../../../helpers/translator";
import Zergling from "../../../helpers/zergling";
import _ from "lodash";
import { toast } from "react-toastify";

const ChangePasswordForm = ({ user, dispatch, popupParams }) => {
	const [form, setForm] = useState({
		password: "",
		new_password: "",
		confirm_password: "",
	});

	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		let interval;

		if (popupParams?.disable) {
			interval = setTimeout(() => {
				dispatch(
					OpenPopup(popupParams.from, {
						disable: popupParams.disable,
						data: popupParams.data,
					})
				);
				this.props.openPopup()();
			}, 5000);
		}

		return () => clearInterval(interval);
	}, [popupParams]);

	const submitActive = useMemo(() => form.password && form.new_password && form.confirm_password, [form]);

	const submit = async e => {
		e.preventDefault();

		if (!submitActive) return;

		if (form.new_password !== form.confirm_password) return setErrorMessage("Passwords don't match");

		const data = await Zergling.get(_.omit(form, "confirm_password"), "update_user_password");

		if (data.result == Zergling.codes.OK) {
			toast.success(t("Password was successfully changed"));
			dispatch(ClosePopup());
			return;
		}

		data.result_text && setErrorMessage(data.result_text);
	};

	const changeField = (name, value) => setForm({ ...form, [name]: value });

	return (
		<>
			<form onSubmit={submit}>
				<div className="popup-contain-table-m login-form-m">
					<div className="center-view-contain-form">
						<div className="mini-logo-view">
							<div className="mini-logo-container" />
						</div>
						<div className="form-contain-box">
							<KeyboardInput
								value={form.password}
								type="password"
								name="password"
								placeholder={t("Current password")}
								onChange={val => changeField("password", val)}
							/>

							<KeyboardInput
								value={form.new_password}
								type="password"
								name="newPassword"
								placeholder={t("New password")}
								onChange={val => changeField("new_password", val)}
							/>

							<KeyboardInput
								value={form.confirm_password}
								type="password"
								name="confirmPassword"
								placeholder={t("Confirm password")}
								onChange={val => changeField("confirm_password", val)}
							/>

							{errorMessage && (
								<div className="login-error">
									<span>{t(errorMessage)}</span>
								</div>
							)}

							<div className="separator-box-buttons-m">
								<button
									type="submit"
									className="button-view-normal-m"
									disabled={!submitActive}
								>
									{t("Confirm")}
								</button>
							</div>
						</div>
					</div>
				</div>
			</form>
			,{user.loginInProgress && <Loader component="changePasswordForm" />}
		</>
	);
};

ChangePasswordForm.propTypes = {
	popupParams: PropTypes.object,
	dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
	user: state.user,
	popupParams: state.uiState.popupParams,
});

export default connect(mapStateToProps)(ChangePasswordForm);
